import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './css/about.css';
import './css/style.css';

import './css/testimonial.css';
import './css/team.css';
import './css/blog.css';
import './css/project.css';
import './css/cta.css';
import './css/video.css';
import './css/page-header.css';
import './css/office-location.css';
import './css/brand.css';
import './css/slider.css';
import './css/banner.css';
import './css/why-choose.css';
import './css/service.css';
import './css/faq.css';
import './css/counter.css';
import './css/quote.css';
import './css/skill.css';
import './css/process.css';
import './css/shop.css';
import './css/pricing.css';
import './css/footer.css';
import './css/contact.css';
import './css/feature.css';
import './css/error.css';
import './css/find-transport.css';
import './css/download-app.css';
import './css/sliding-text.css';


import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
